import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import './Credit.css';
import User from '../../User';
import Lightbox from '../utility/Lightbox';

export default class Credit extends Component {

  state = {
    status: null,
    shards: User.shards
  };

  /*componentDidMount() {

    User.credit = this;
  }

  componentWillUnmount() {

    if (User.credit === this)
      delete User.credit;
  }*/

  /*handleShardsChange = (newShards) => {
    this.setState({ shards: newShards });
  };

  handleRunesChange = (newRunes) => {
    this.setState({ runes: newRunes });
  };*/

  render () {

    return (
      <div>
        <Lightbox className="small shard-info-lightbox" open={this.state.status === "shards"} onClose={() => this.setState({status: null})}>
          <div className="shard-info">
            <h1><img src="/images/soulshard.png" alt=""/>{translate("Experience shards")}</h1>
            <p>{translate("At the end of a run, half your unused exp gets converted into shards. Offer them to celestials in the pantheon for upgrades.")}</p>
          </div>
        </Lightbox>
        <div className="nav-item nav-credit" onClick={() => this.setState({status: "shards"})}>
          <div id="shard-count" className="nav-credit-count">{ User.shards }</div>
          <img className="soulshard-icon" src="/images/soulshard.png" alt=""/>
        </div>
      </div>
    );
  }
}

